// Copyright (c) 2017 Deere & Company

import AuditStatus, {getDefaultState as getAuditStatusDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-status';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import t from 'tcomb';

const State = t.struct({
    auditStatus: AuditStatus,
    busyCounter: BusyCounter,
    showNoResultsFound: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        auditStatus: getAuditStatusDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        showNoResultsFound: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/audit-status/state/index.js